import { render } from "./CirclePointer.vue?vue&type=template&id=b159f96a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/CirclePointer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b159f96a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b159f96a', __exports__)) {
    api.reload('b159f96a', __exports__)
  }
  
  module.hot.accept("./CirclePointer.vue?vue&type=template&id=b159f96a", () => {
    api.rerender('b159f96a', render)
  })

}


export default __exports__